import { motion } from 'framer-motion';
import { useLanguage } from '../../lib/i18n/LanguageContext';
import SectionTitle from '../../components/ui/SectionTitle';

const ContactFAQ = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-neutral-50">
      <div className="container-custom">
        <SectionTitle title={t.contact.faq.title} subtitle={t.contact.faq.subtitle} />

        <div className="max-w-3xl mx-auto mt-12 space-y-6">
          {t.contact.faq.items.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <h3 className="font-serif text-base lg:text-lg font-semibold text-neutral-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-neutral-700 text-base leading-relaxed">{faq.answer}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactFAQ;
